function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


var bundleAppBaseUrl = 'https://www.chummat.com/iabapp';
if (window.location.hostname === 'iambecoming.com') {
  bundleAppBaseUrl = 'https://www.chummat.com/iabappdev';
}

var cartObject = null;


var autoplay = 6000;

$(document).ready(function() {
  
  $('.cart__submit').prop("disabled", false);
  
  var commonPage = {
    init: function() {
      this.initHeader();
      this.onModal();
      this.initCart();
    },

    initHeader: function() {
      var navbar = document.getElementById("navmenu-header");
      var sticky = navbar.offsetTop;

      window.onscroll = function() {
        if (window.pageYOffset > sticky) {
          navbar.classList.add("sticky")
        } else {
          navbar.classList.remove("sticky");
        }
      };

      // Header msg slider
      $('.msg_slick').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        nextArrow: '<i class="fa fa-angle-right"></i>',
        prevArrow: '<i class="fa fa-angle-left"></i>',
        infinite: true
      });
    },

    onModal: function() {
      $('.call_subscribe').on('click', function () {
        $('#mailchimp-popup').fadeIn();
        $('#mailchimp-popup').addClass('modal--is-active');
      });

      window.onclick = function(event) {
        if (event.target.classList.contains('modal-overlay')) {
          $(event.target).closest('.modal').fadeOut();
        }
      }
    },

    initCart: function() {
      //if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
      var $L = 1200,
      $cart_trigger = $('.cd-cart-trigger'),
      $lateral_cart = $('#cd-cart'),
      $shadow_layer = $('#cd-shadow-layer'),
      $close_pop = $('#close-pop');

      //open cart
      $cart_trigger.on('click', function(event){
        event.preventDefault();

        if ($('body').hasClass('cart-has-subscription')) {
          window.location.href = '/cart';
        } else {
          //close lateral menu (if it's open)
          toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
        }
      });

      //close lateral cart or lateral menu
      $shadow_layer.on('click', function(){
        $shadow_layer.removeClass('is-visible');
        // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
        if( $lateral_cart.hasClass('speed-in') ) {
          $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
            $('body').removeClass('overflow-hidden');
          });
        } else {
          $lateral_cart.removeClass('speed-in');
        }
      });
      //close lateral cart or lateral menu
      $close_pop.on('click', function(){
        $shadow_layer.removeClass('is-visible');
        // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
        if( $lateral_cart.hasClass('speed-in') ) {
          $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
            $('body').removeClass('overflow-hidden');
          });
        } else {
          $lateral_cart.removeClass('speed-in');
        }
      });

      $('.continue-shopping').click(function() {
        const url = getCookie('last_collection_url');

        if (url === location.href) {
          // Just close the drawer cart
          $close_pop.trigger('click');
          return;
        }
        if (url) {
          location.href = url;
        } else {
          location.href = '/';
        }

        return false;
      });
    }
  };

  /*============================================================================
    Image Functions
  ==============================================================================*/

  var imageFunctions = {
    zoom: function(zoomParent, enableTouch, magnify){
      
    }
  }

  /*============================================================================
    Product Page
  ==============================================================================*/

  var productPage = {
    init: function() {
      this.initZoom();
      this.initAccordion();
      this.onChangeQuantity();
      this.initInfoPan();
      initZoomSlider();
    },

    initZoom: function() {
      imageFunctions.zoom('.product_gallery', false);
      $('.gallery-btn').click(function() {
        if ($(this).hasClass('gallery-left')) slide('left');
        if ($(this).hasClass('gallery-right')) slide('right');
      });
      function slide(dir) {
        var $el = $('.product_gallery');
        var width = $el.width();
        var left = $el.scrollLeft();
        if (dir == 'left') left -= width;
        if (dir == 'right') left += width;
        if (dir == 'first') left = 0;
        if (dir == 'last') left = $el[0].scrollWidth - width;
        if (left < 0) left = 0;
        if (left > $el[0].scrollWidth - width) left = $el[0].scrollWidth - width;
        $('.product_gallery').animate({scrollLeft: left}, 300, function() {
          $('.gallery-btn').show();
          if (left == 0) $('.gallery-left').hide();
          if (left == $el[0].scrollWidth - width) $('.gallery-right').hide();
        });
      }
      if ($('.gallery-btn').is(':visible')) slide('first');
    },

    initAccordion: function() {
      //-- product page accordion for sidebar
      $(".product-single__description").on("click", ".description_title", function() {
        const target = $(this).data('target');
        if (target) {
          const $target = $(target);
          $('html, body').animate({
            scrollTop: $target.offset().top - $(".navmenu-header").height() * 2
          }, 500);
        } else {
          $(this).toggleClass("active").next().slideToggle();
        }
      });
    },

    onChangeQuantity: function() {
      $(document).on('click', '.js-change-quantity', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 10000000,
            valMin = $input.attr('min') || 0;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }

        if($this.data('func') == 'plus') {
            if(val < valMax) $input.val(val + 1);
        } else {
            if(val > valMin) $input.val(val - 1);
            if($this.parents(".cart_item").length) {
              if (val - 1 == 0) {
                $this.closest('.cart_item').addClass('animated fadeOutUp')
              }
            }
        }

        $input.trigger('change');

      }).on("change", "#cart_form input.quantity", function() {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));

      }).on("change", ".cart_content input.quantity", function() {
        ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
      });
    },

    initInfoPan: function () {
      /*var $navbar = $('#navmenu-header');
      var $wrap = $('#product-info-wrap');
      var width = $wrap.width();
      var height = $wrap.height();
      
      $(window).scroll(function() {
        var sticky = $wrap.parent().offset().top;
        var container_height = $wrap.parent().parent().height();
        if ($(window).scrollTop() >= sticky) {
          if ($(window).scrollTop() >= sticky + container_height - height - 80) {
            $wrap.removeClass('sticky').addClass('bottom');
          } else {
            $wrap.addClass('sticky');
            $wrap.css('width', width + 'px');
          }
        } else {
          $wrap.removeClass('sticky bottom');
        }
      });*/

      $('.social-sharing-btn').click(function() {
        $(this).toggleClass('active');
        $('.social-sharing-wrap').toggleClass('active');
      });
      $(document).on('click', '.review-trigger, .spr-summary-actions-newreview', function(e) {
        e.preventDefault();
        if ($('.spr-form form').length) {
          $('.spr-form').modal({
            minWidth: 350
          });
        }
      });
    }
  };

  var collectionPage = {
    init: function() {
      this.initStickySidebar();

      /*
      if(!$('.product-slider').hasClass('flickity-enabled')){
        $('.product-slider').flickity({
          draggable: true,
          freeScroll: false,
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          lazyLoad: true
        });
      }
      */
    },

    initStickySidebar: function() {
      $('#sticky-sidebar').stickySidebar({
          topSpacing: 75,
          bottomSpacing: 235,
          containerSelector: '#sticky-wrapper',
          innerWrapperSelector: '.sticky-inner',
          minWidth: 768
      });
    }
  };

  commonPage.init();
  productPage.init();
  collectionPage.init();
});

// swatch color click
$(window).on('load', function(){
  $('.swatchColor').on('click', function() {
    var currentSwatch = $('.swatchColor.currentSwatch');
    var current_swatch_attr = currentSwatch.attr("data-name");
    $('.product_gallery_nav .gallery-cell[data-variant-color-name = "' + current_swatch_attr + '"]').trigger( "click" );
  });
});

if ($(window).width() > 768) {
  $('.collection-grid--item').hover(function(){
    $(this).find('.overlay_collection p').slideDown('100');
  }, function(){
    $(this).find('.overlay_collection p').slideUp('100');
  });
}

function toggle_panel_visibility ($lateral_panel, $background_layer, $body) {
	if( $lateral_panel.hasClass('speed-in') ) {
		// firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		$lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.removeClass('overflow-hidden');
		});
		$background_layer.removeClass('is-visible');
	} else {
		$lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
			$body.addClass('overflow-hidden');
		});
		$background_layer.addClass('is-visible');
	}
}

// --- Ajax cart on collection page ( quick buy )
function reloadCart(bToggleDrawer) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    headers: {
        'Content-Type': 'application/json'
    },
    success: function(jqXHR){
      rebuildMiniCart(jqXHR, bToggleDrawer);
    }
  });
}

function onQuickBuyButtonClicked(el) {
  const quickBuyButton = el;
  const CartCount = $('.cart_count');
  const AddToCartSvg = quickBuyButton.firstElementChild;
  const addingClass = 'add-success--adding';
  const addedClass = 'add-success--added';
  let activeVariant = quickBuyButton.dataset.cartAdd;
  let adding = false;
  let compare_at_price = quickBuyButton.dataset.comparePrice;

  if (adding) return false;

  if (activeVariant.length === 0) {
      return false;
  }

  adding = true;

  AddToCartSvg.classList.add(addingClass);

  const product = {
    id: activeVariant,
    quantity: 1
  };

  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(product),
      dataType: 'json',
      headers: {
          'Content-Type': 'application/json'
      },
    success: function(){
      currentVal = parseInt(CartCount[0].innerText, 10);
      CartCount.html(currentVal + 1);

      setTimeout(function() {
          quickBuyButton.classList.add('blue-border');
          AddToCartSvg.classList.add(addedClass);
      }, 150);

      setTimeout(function() {
        reloadCart(true);
      }, 600);

      setTimeout(function() {
          AddToCartSvg.classList.remove(addedClass, addingClass);
          quickBuyButton.classList.remove('blue-border');
      }, 800);

      const currentPage = 'collection';

//       if (currentPage === 'cart') {
//           setTimeout(function() {
//               location.reload()
//           }, 1500);
//       }
      
      if (currentPage === 'cart') {
          setTimeout(function() {
              location.reload()
          }, 500);
      }      

      adding = false;
  },
  error: function(errorThrown) {
      console.log('Failed To Add', errorThrown);
  }});
}

function rebuildMiniCart(cart, bToggleDrawer) {
  refreshCart(cart);

  if (bToggleDrawer) {
    if ($('body').hasClass('cart-has-subscription')) {
      window.location.href = '/cart';
      return;
    }

    $lateral_cart = $('#cd-cart');
    $shadow_layer = $('#cd-shadow-layer');
    toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
  }
}

//--- modal hide----

function modalHide() {
  $(".modal").addClass("zoomOut animated").fadeOut();
  $(".modal").removeClass("zoomOut animated");
}

var newsletter_popup = {
  init: function(){
    var popup = Cookies('popup');
    var cookie_enabled = true;

    if (cookie_enabled && popup == 'open') {
        return false;
    } else {
      newsletter_popup.open();
    }
    if (cookie_enabled) {
      Cookies('popup', 'open', { expires: 1 });
    }
  },
  open: function(){
    if ($(window).width() > 768) {
      setTimeout( function() {
        // $('[data-remodal-id=newsletter]').remodal().open();
      },
      2000);
    }
  }
}

newsletter_popup.init();

var $contact_form = $('.newsletter .contact-form');
$contact_form.each(function() {
  var $cf = $(this);
  $cf.on("submit", function (e) {
    
      $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $(this).prev('.message').html("translation missing: en.general.newsletter_form.success_text");
            });
          }
      });
      e.preventDefault();
    
  });
});


/*============================================================================
  Start of cart-related functionality
==============================================================================*/

function ajaxSubmitCart(cart) {
  $cart = cart;
  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    type: 'post',
    data: $cart.serialize(),
    success: function (data) {
      refreshCart(data);
    }
  });
}

function ajaxUpdateCart(lineID, quantity, parent) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    type: 'post',
    data: {
      quantity: quantity,
      line: lineID
    },
    success: function (data) {
      refreshCart(data);
      if (typeof data.items[lineID - 1] !== 'undefined') {
        updated_quantity = data.items[lineID - 1].quantity;
      } else {
        updated_quantity = 0;
      }

      if(quantity > 0 && quantity != updated_quantity) {
        if (updated_quantity == 1) {
          items_left_text = '"item left"';
        }
        else {
          items_left_text = '"items left"';
        }

        $('.warning--quantity').remove();

        var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
        parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
        parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
      } else if (parent.is('#cart_form')) {
        $("#cart_form").submit();
      }
    }
  });
}

function refreshCart(cart) {
  $cartBtn = $(".cart_count");
  var value = $cartBtn.text() || '0';
  var cart_items_html = "";
  var cart_action_html = "";
  var $cart = $(".cart_content form");

  $cartBtn.text(cart.item_count);

  $('body').removeClass('cart-has-subscription');

  if (cart.item_count == 0) {
    $('.js-empty-cart__message').removeClass('hidden');
    $('.js-cart_content__form').addClass('hidden');

  } else {
    $('.js-empty-cart__message').addClass('hidden');
    $('.js-cart_content__form').removeClass('hidden');

    $.each(cart.items, function(index, item) {
      var item_handle = item.handle;
      var item_variant = item.variant_id;
      var item_price = item.price;
      var item_url = item.url;
      var compare_at_price = null;
      var compare_at_price_string = '';

      if (item.properties && typeof item.properties.shipping_interval_frequency !== 'undefined') {
//         REMOVE
//         console.log(item_handle, item_url);
        item_handle = item_handle.replace(/\b-1$/,'');
        item_url = item.url.replace(/\b-1\?\b/, '?');

        $('body').addClass('cart-has-subscription');
      }

      jQuery.getJSON('/products/' + item_handle + '.js', function(data) {
        $.each(data.variants, function(index, v_item) {
          
            if (item_variant == v_item.id) {
              compare_at_price = v_item.compare_at_price;

            }
            try {
              if(compare_at_price !== null && compare_at_price > item_price) {
                compare_at_price_string = ' <del style="color:red">'+ Shopify.formatMoney(compare_at_price, $cart.data('money-format')) + '</del>';
                return false;
              }
            } catch(e) {
              compare_at_price = null;
            }

          
        });

        var line_id = index + 1;
        cart_items_html += '<li class="cart_item clearfix">' +
          '<a href="' + item_url +'">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }
        cart_items_html += '<div class="item_title">' + item.title + '</div>';

        
          cart_items_html += '<span class="eee price_sb right">' + Shopify.formatMoney(item_price, $cart.data('money-format')) + compare_at_price_string + '</span>';
        

        //cart_items_html += '<strong class="right price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</strong>' +
          //'<div class="item_title">' + item.title + '</div>' +
        cart_items_html += '</a>';

        // Cart Item properties
        cart_items_html += '<div class="product-properties">';
        for (var key in item.properties) {
            if (key[0] === '_') {
                continue;
            }
            cart_items_html += '<div class="property-line"><span class="property-name">' + key + ':</span> <span class="property-value">' + item.properties[key] + '</span></div>';
        }
        cart_items_html += '</div>';

        cart_items_html += '<div class="left product-quantity-box">' +
            '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><i class="fa fa-minus"></i></span>' +
            '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
            '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><i class="fa fa-plus"></i></span>' +
          '</div>' +
        '</li>';

        $('.js-cart_items').html(cart_items_html);
      });

      

    });

    cart_action_html += '<span class="cart_subtotal--price right">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</span>' +
        '<span>Subtotal</span>';
  }


  $('.js-cart_subtotal').html(cart_action_html);

  

  // Check Bundle app
  loadBundleDiscountForDrawer(cart);
}

function loadBundleDiscountForDrawer(cart)
{
  if (!cart) {
    return;
  }

  $.ajax({
    url: bundleAppBaseUrl + '/bundle',
    type: "POST",
    dataType: 'json',
    data: {
      target: 'recharge_bundle',
      cmd: 'get_discount_amount',
      cartData: JSON.stringify(cart)
    },
    success: function (response) {
      if (typeof response.discount_amount !== 'undefined') {
        redrawSubtotalForDrawer(response);
      }
    },

    error: function(xhr) {
      console.log(xhr);
      //alert('Error: while checking reCharge discount code.');
    }
  });
}

function redrawSubtotalForDrawer(cartMeta)
{
  var subtotal = cartMeta.cart_total - cartMeta.discount_amount;
  $(".cart_subtotal--price").html('$ ' + subtotal.toFixed(2));

  var $discount = $('.cart_discount');
  if (cartMeta.discount_amount > 0) {
    $discount.find('.cart_discount--price').html('-$ ' + cartMeta.discount_amount.toFixed(2));
    $discount.show();
  } else {
    $discount.hide();
  }
}

// Load discount at page loading
loadBundleDiscountForDrawer(cartObject);

//Used for cart functionality
function htmlEncode(value){
  if (value) {
      return $('<div/>').text(value).html();
  } else {
      return '';
  }
}

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};


timber_productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $saveAmount = $('#SaveAmount'),
      $saveper = $('#saveper'),
      $priceCompare = $('#price-compare'),
      $quantityElements = $('.qty-block'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.show();
      $("button#outofstcok1").hide();
      $addToCartText.html("Add to cart");
      $quantityElements.show();
      $(".instock").html("Quantity in Stock :" +variant.inventory_quantity ).show();
      $(".nostock").hide();
      $("#notifyme").hide();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.hide();
      $("button#outofstcok1").show();
      $("#notifyme").show();
      $(".nostock").text("Out of stock").show();
      $(".instock").hide();
      $quantityElements.hide();

    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
      $saveAmount.html(Shopify.formatMoney((variant.compare_at_price - variant.price), moneyFormat));
      $saveper.html("("+((variant.compare_at_price - variant.price)/variant.compare_at_price*100).toFixed(0)+"%)");
      $priceCompare.show();
    } else {
      $priceCompare.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.hide();
      $("button#outofstcok1").show();
      $(".nostock").text("Out of stock");
      $(".instock").hide();
      $quantityElements.hide();
    $("#notifyme").show();
  }
};

// Load sidebar cart again for Discount
reloadCart(false);


function initZoomSlider() {
    const Html = document.getElementsByTagName('html')[0];
    const Zoom = document.createElement('section');
    const ZoomImages = document.createElement('div');
    const ButtonUp = document.createElement('button');
    const ButtonDown = document.createElement('button');
    const CloseZoom = document.createElement('button');
    const images = jQuery('.product_gallery .gallery-cell');
    const activeThumbClass = 'product-zoom__thumbs__wrap--active';

    let viewportHeight = document.documentElement.clientHeight;
    let width = document.body.clientWidth;
    let isActive = false;
    let imagesArray = [];
    let activeId;

    if (images.length <= 1) return false;

    for (var i = 0; i < images.length; i += 1) {
        const img = images[i];
        const id = parseFloat(img.dataset.id, 10);

        imagesArray.push({
            id: id,
            large: img.dataset.image,
            thumb: img.dataset.thumb
        });

        img.addEventListener('click', function () {
            const zoom = document.documentElement.clientWidth / window.innerWidth;

            if (width < 768) {
                initPinchZoom(img.dataset.image, zoom);

                return false;
            }

            activeId = id;
            ZoomImages.style.top = '-' + viewportHeight * (activeId - 1) + 'px';

            if (isActive) {
                Zoom.classList.add('product-zoom--active');
                updateActiveImage(id);
                moveThumbs();

                return false;
            }

            buildZoomSlider();
        });
    }

    function destroyZoomSlider() {
        Html.classList.remove('scroll-lock');
        Zoom.classList.remove('product-zoom--active');
    }

    function scrollToImage(id, thumbnail, dir) {
        const activeId = thumbnail ? id + 1 : id;

        ZoomImages.style.top = '-' + (activeId - 1) * viewportHeight + 'px';

        updateActiveImage(activeId);
        if (dir) moveThumbs(dir);
    }

    function updateActiveImage(id) {
        const prevThumb = document.getElementsByClassName(activeThumbClass)[0];
        const activeThumb = document.getElementById('zimage-' + id);

        prevThumb.classList.remove(activeThumbClass);
        activeThumb.classList.add(activeThumbClass);

        ButtonDown.classList.remove('hidden');
        ButtonUp.classList.remove('hidden');

        if (id === 1) ButtonUp.classList.add('hidden');
        if (id === imagesArray.length) ButtonDown.classList.add('hidden');

        activeId = id;
    }

    function moveThumbs(dir) {
        const ThumbnailsWrap = document.getElementsByClassName('product-zoom__thumbs')[0];
        const thumbs = document.getElementsByClassName('product-zoom__thumbs__wrap');

        Array.from(thumbs).forEach(function (thumb, i) {
            if (thumb.classList.contains(activeThumbClass)) {
                if (dir === 'down') {
                    ThumbnailsWrap.scrollBy({
                        top: 75,
                        behavior: 'smooth'
                    });
                } else if (dir === 'up') {
                    ThumbnailsWrap.scrollBy({
                        top: -75,
                        behavior: 'smooth'
                    });
                }
            }
        });

        if (thumbs.length > 6 && !dir) {
            ThumbnailsWrap.scrollTo({ top: (activeId - 1) * 75 });
            updateActiveImage(activeId);
        }
    }

    function buildZoomSlider() {
        if (isActive) return false;

        function toggleZoom(e, ZoomItem, show) {
            const image = ZoomItem.getElementsByTagName('img')[0];
            const overlay = ZoomItem.getElementsByClassName('zoom-overlay')[0];

            if (!show) {
                overlay.style.opacity = '0';
                return false;
            }

            const offsetX = e.offsetX ? e.offsetX : (e.touches && e.touches[0].pageX);
            const offsetY = e.offsetY ? e.offsetY : (e.touches && e.touches[0].pageY);
            const x = offsetX / image.offsetWidth * 100
            const y = offsetY / image.offsetHeight * 100

            overlay.style.backgroundPosition = x + '% ' + y + '%';
            overlay.style.width = image.offsetWidth + 'px';
            overlay.style.opacity = '1';
        }

        function buildThumbnails(images) {
            const SliderWrap = document.createElement('div');
            const Thumbnails = document.createElement('div');

            for (var i = 0; i < images.length; i += 1) {
                const ThumbnailItem = document.createElement('div');
                const Img = document.createElement('img');
                const img = images[i];

                Img.src = img.thumb;

                if (img.id === activeId) {
                    ThumbnailItem.classList.add(activeThumbClass);
                }

                ThumbnailItem.classList.add('product-zoom__thumbs__wrap');
                ThumbnailItem.id = 'zimage-' + img.id;
                ThumbnailItem.appendChild(Img);

                ThumbnailItem.addEventListener('click', function () {
                    scrollToImage(img.id - 1, true);
                });

                Thumbnails.appendChild(ThumbnailItem);
            }

            ButtonUp.classList.add('product-zoom__wrapper__up');
            ButtonDown.classList.add('product-zoom__wrapper__down');

            if (activeId === 1) ButtonUp.classList.add('hidden');
            if (activeId === images.length + 1) ButtonDown.classList.add('hidden');

            ButtonUp.addEventListener('click', function () {
                scrollToImage(activeId - 1, false, 'up');
            });

            ButtonDown.addEventListener('click', function () {
                scrollToImage(activeId + 1, false, 'down');
            });

            SliderWrap.appendChild(ButtonUp);
            SliderWrap.appendChild(ButtonDown);
            SliderWrap.appendChild(Thumbnails);
            SliderWrap.classList.add('product-zoom__wrapper');
            Thumbnails.classList.add('product-zoom__thumbs');

            return SliderWrap;
        }

        function buildImages(images) {
            for (var i = 0; i < images.length; i += 1) {
                const ZoomImageWrap = document.createElement('div');
                const ZoomImageOverlay = document.createElement('div');
                const Img = document.createElement('img');
                const img = images[i];

                Img.dataset.src = img.large;
                Img.classList.add('lazyload');

                ZoomImageOverlay.style.backgroundImage = 'url(' + img.large + ')';
                ZoomImageOverlay.classList.add('zoom-overlay');

                ZoomImageWrap.classList.add('product-zoom__images__wrap', 'preloader');
                ZoomImageWrap.appendChild(Img);
                ZoomImageWrap.appendChild(ZoomImageOverlay);

                ZoomImages.appendChild(ZoomImageWrap);

                Img.addEventListener('mousemove', function (e) {
                    toggleZoom(e, ZoomImageWrap, true);
                });

                Img.addEventListener('mouseout', function (e) {
                    toggleZoom(e, ZoomImageWrap, false);
                });
            }

            ZoomImages.classList.add('product-zoom__images');

            return ZoomImages;
        }

        CloseZoom.addEventListener('click', function () {
            destroyZoomSlider();
        });
        CloseZoom.classList.add('product-zoom__close');

        Zoom.classList.add('product-zoom', 'product-zoom--active');
        Zoom.appendChild(CloseZoom);
        Zoom.appendChild(buildImages(imagesArray));
        Zoom.appendChild(buildThumbnails(imagesArray));

        Html.classList.add('scroll-lock');
        document.body.appendChild(Zoom);
        moveThumbs();
        isActive = true;
    }

    function resizeSlider() {
        viewportHeight = document.documentElement.clientHeight;

        ZoomImages.style.top = '-' + (activeId - 1) * viewportHeight + 'px';
    }

    window.addEventListener(
        'resize',
        function () {
            const images = document.getElementsByClassName('gallery-cell');
            width = document.body.clientWidth;

            if (width < 1024) {
                destroyZoomSlider();
            }

            if (width > 1024) {
                for (var i = 0; i < images.length; i += 1) {
                    const img = images[i];

                    img.removeEventListener('click', function () {
                        initPinchZoom(img.dataset.image);
                    });
                };
            }

            if (width < 768) {
                for (var i = 0; i < images.length; i += 1) {
                    const img = images[i];

                    img.addEventListener('click', function () {
                        initPinchZoom(img.dataset.image);
                    });
                };
            }

            resizeSlider();
        },
        false
    );
}

let stopZoom = false;

function initPinchZoom(src, scale) {
    const ZoomContainer = document.createElement('div');
    const CloseZoom = document.createElement('button');
    const ZoomTouch = document.createElement('pinch-zoom');
    const className = 'product-mobilezoom';
    const zoomLength = document.getElementsByClassName(className).length;
    const pinchCookie = getCookie('iabmfg-pinch-zoom');

    if (!isInternetExplorer || /Edge/.test(navigator.userAgent)) return false;

    if (scale && scale > 1) {
        stopZoom = true;
        return false;
    }

    if (scale === 1) {
        stopZoom = false;
    }

    if (stopZoom) return false;

    function buildZoom() {
        ZoomContainer.classList.add(className, className + '--active', 'preloader');
        ZoomContainer.appendChild(ZoomTouch);
        ZoomContainer.appendChild(CloseZoom);

        ZoomTouch.setAttribute('min-scale', 1.5);
        ZoomTouch.setAttribute('max-scale', 3);

        CloseZoom.classList.add(className + '__close');
        CloseZoom.addEventListener('click', function () { destroyZoom(); });

        // ZoomTouch.appendChild(appendImage(ZoomTouch));
        appendImage(ZoomTouch);
        ZoomTouch.style.opacity = 0;

        if (!pinchCookie) {
            const Guide = document.createElement('div');
            Guide.classList.add(className + '__guide');

            ZoomContainer.appendChild(Guide);

            setCookie('pdp-pinch-zoom', true, 30);

            setTimeout(function () {
                Guide.style.opacity = 0;
                Guide.style.display = 'none';
            }, 1500);
        } else {
            // Renew cookie
            setCookie('pdp-pinch-zoom', true, 30);
        }

        document.body.appendChild(ZoomContainer);
    }

    function appendImage(ZoomTouch) {
        const Img = new Image();
        Img.src = src;

        Img.onload = function () {
            // Img.style.marginLeft = '-' + Img.width * 1.5 / 2 + 'px';

            ZoomTouch.style.opacity = 1;
            // ZoomTouch.setTransform({
            //     scale: 1.5,
            //     x: 0,
            //     y: 0
            // });
        };

        // return Img;
        ZoomTouch.appendChild(Img);
        new PinchZoom(Img, {initialZoom: 1.5});
    }

    function destroyZoom() {
        ZoomTouch.removeChild(ZoomTouch.children[0]);
        ZoomTouch.style.opacity = 0;

        ZoomContainer.classList.remove(className + '--active');
    }

    if (zoomLength > 0) {
        const zoomTouch = document.getElementsByTagName('pinch-zoom')[0];
        const zoomContainer = document.getElementsByClassName(className)[0];

        zoomContainer.classList.add(className + '--active');
        // zoomTouch.appendChild(appendImage(zoomTouch));
        appendImage(zoomTouch);
    } else {
        buildZoom();
    }
}

function isInternetExplorer() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return (msie > 0 || trident > 0);
}

function isOS() {
    return navigator.userAgent.match(/ipad|iphone/i);
}

function setCookie(name, value, days) {
    let expires = '';

    if (days) {
        const date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i += 1) {
        let c = ca[i];

        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
}

function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}
